import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from 'store/store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useBaoDispatch = () => useDispatch<AppDispatch>();
export const useBaoSelector: TypedUseSelectorHook<RootState> = useSelector;
